import { ref } from 'vue';
import CustomThemesAPI from 'dashboard/api/customThemes';

export const customThemes = ref([]);
export const customThemesLoaded = ref(false);

export const loadCustomThemes = async () => {
  const { data } = await CustomThemesAPI.get();
  customThemes.value = data.payload || [];
  customThemesLoaded.value = true;
  return customThemes.value;
};

export const findCustomTheme = key => {
  if (!key?.startsWith('custom:')) return null;
  return customThemes.value.find(theme => `custom:${theme.id}` === key) || null;
};
